// frontend/packages/business-console/src/services/billingHistoryService.js
//
// Thin wrapper over GET /api/v2/business/billing/history — the tenant's
// own UpRyzze billing history (subscription summary + invoices/receipts).
// Business context comes from the x-business-id header (axios
// interceptor); callers don't pass it. Response is display-safe: no
// internal Stripe ids, but it does include Stripe's payer-facing hosted
// invoice + PDF links.

import { api } from '@upryzze/services';

/**
 * @returns {Promise<{
 *   subscription: {
 *     status: string, amount: number, currency: string,
 *     interval: string, currentPeriodEnd: string|null,
 *     cancelAtPeriodEnd: boolean,
 *   } | null,
 *   invoices: Array<{
 *     number: string, status: string, currency: string,
 *     amountDue: number, amountPaid: number, description: string,
 *     dueDate: string|null, issuedAt: string|null,
 *     hostedInvoiceUrl: string, invoicePdfUrl: string,
 *     lineItems: Array<{ description: string, quantity: number,
 *                        unitAmount: number, amount: number }>,
 *   }>,
 * }>}
 */
export async function getBillingHistory() {
  const { data } = await api.get('/v2/business/billing/history');
  return data;
}

/**
 * Schedule the end of the tenant's UpRyzze plan (businessadmin only). The
 * plan stays active until the end of the period already paid for (or the
 * free trial) and is not charged again.
 * @returns {Promise<{ subscription: { status: string,
 *   cancelAtPeriodEnd: boolean, currentPeriodEnd: string|null } }>}
 */
export async function cancelSubscription() {
  const { data } = await api.post('/v2/business/billing/subscription/cancel');
  return data;
}

/** Withdraw a scheduled cancel while the period is still running. */
export async function resumeSubscription() {
  const { data } = await api.post('/v2/business/billing/subscription/resume');
  return data;
}
